export enum UniqueAIObjectCreationMode {
  CreateNew = 0,
  SelectExisting = 1,
  CreateNewFromExisting = 2,
}
